module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/buttons/delete-btn/delete-btn.scss
// module id = ./web/modern/components/buttons/delete-btn/delete-btn.scss
// module chunks = 0